<script lang="ts">
  import { onMount } from "svelte";
  import { ApiService } from "../../services/api.service";
  import BlueButton from "../BlueButton.svelte";

  import FormWithLabel from "../../molecules/FormWithLabel.svelte";
  import SectionBoard from "../../molecules/SectionBoard.svelte";

  let loading = false;

  let head = "";

  const handleHead = (event) => {
    head = event.detail.value;
  };

  onMount(async () => {
    const client = ApiService.createClient();
    const { data } = await client.get("/settings/head");
    if (!data.head) {
      return;
    }
    head = data.head;
    console.log(head);
  });

  const saveHead = async () => {
    const client = ApiService.createClient();
    loading = true;
    const { data } = await client.post("/settings/head", {
      value: head,
    });
    console.log(data);
    loading = false;
  };
</script>

<SectionBoard>
  <h2 class="font-semibold">共通ヘッド</h2>

  <div class="mt-6">
    <FormWithLabel
      label="コード"
      input={handleHead}
      value={head}
      inputType="textarea"
    />
  </div>

  <BlueButton rounded klass="mt-4" click={saveHead} {loading}>
    更新する
  </BlueButton>
</SectionBoard>
